import {
  useCompany,
  useGetUsers,
  usePermissions,
} from '@dispatch/shared/hooks';
import { UserFilters } from '@dispatch/shared/types';
import { Users } from '@dispatch/web/features/users';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDebounce } from 'react-use';

export const UsersPage = () => {
  const { roles } = useCompany();
  const { permissions } = usePermissions();
  const [searchText, setSearchText] = useState('');
  const defaultFilters: UserFilters = {
    pageSize: 10,
  };
  const [filters, setFilters] = React.useState<UserFilters>(defaultFilters);
  const [debouncedFilters, setDebouncedFilters] = React.useState<
    UserFilters | undefined
  >(undefined);

  useDebounce(
    () => setDebouncedFilters({ ...filters, name: searchText }),
    500,
    [filters, searchText]
  );

  const usersData = useGetUsers(debouncedFilters);

  const onSearch = (value: string) => {
    setSearchText(value);
  };

  const onPageSizeChange = (pageSize: number) => {
    setFilters({ ...filters, pageSize });
  };

  return (
    <>
      <Users
        rows={usersData.data || []}
        onSearch={onSearch}
        status={usersData.status}
        permissions={permissions}
        onPageSizeChange={onPageSizeChange}
        usersData={usersData}
        roles={roles}
      />
      <Outlet />
    </>
  );
};
